import React, { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import { API_DOMAIN } from './globals'; // Import the global domain name

function Layout() {

    // let Coins = sessionStorage.getItem('Coins');
    // let Exposure = sessionStorage.getItem('Exposure');
    const ClientCode = sessionStorage.getItem('ClientCode');
    const ClientName = sessionStorage.getItem('ClientName');

    const [Coins, setCoins] = useState(true);  // Loading state
    const [Exposure, setExposure] = useState(true);  // Loading state
    
    const [myLiveMessage, setLiveMessage] = useState([]);  // Store the API response

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    useEffect(() => {

        setCoins(sessionStorage.getItem('Coins'));
        setExposure(sessionStorage.getItem('Exposure'));

        // Define your parameters
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        // Create an object to pass parameters to the GET request
        const params = {
            ut: param1,
            un: param2,
        };

        // const queryString = new URLSearchParams(params).toString();
        // const url = `${API_DOMAIN}/api/Client/getLiveMessage.php?${queryString}`;

        // fetch(url, {
        //     method: 'GET',
        //     credentials: 'include', // Equivalent to withCredentials:true
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        // })
        //     .then(response => response.json())
        //     .then(data => {
        //         if (data.Status == "Error") {
        //             window.location = '/';
        //         } else {
        //             //console.log(data.data);
        //             setLiveMessage(data.LiveMessage); // Save the response data in state
        //         }
        //         setLoading(false); // Set loading to false
        //     })
        //     .catch(err => {
        //         setError(err); // Save any error to the state
        //         setLoading(false); // Set loading to false
        //     });
        
        const queryString1 = new URLSearchParams(params).toString();
        const url1 = `${API_DOMAIN}/api/Client/getClientDetails.php?${queryString1}`;

        fetch(url1, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    console.log(data.Message);
                    //window.location = '/';
                } else {
                    
                    setLiveMessage(data.LiveMessage); // Save the response data in state

                    sessionStorage.setItem('Coins', data.data[0].Coins);
                    sessionStorage.setItem('Exposure', data.data[0].Exposure);

                    setCoins(data.data[0].Coins);
                    setExposure(data.data[0].Exposure);
                    
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <header style={{backgroundColor:'#622569', padding:'0px'}}>
                <div className="header-inner" style={{backgroundColor:'#622569'}}>
                    {/* <input type="checkbox" id="drawer-toggle-right" name="drawer-toggle-right" />
                    <label className="button" htmlFor="drawer-toggle-right" id="drawer-toggle-label-right"></label> */}
                    {/* <nav id="drawer-right">
                        <label className="button" htmlFor="drawer-toggle-right" id="drawer-toggle-close-right"></label>
                        <div className="right-bet-inner">

                            <div className="mod-header tab_bets betsheading" style={{ display: 'block' }}>
                                <ul className="nav nav-pills mb-1" id="pills-tab" role="tablist">
                                    <li className="nav-item betdata active">
                                        <a className="allbet" ng-click="DisplayBets('All')">
                                            <span className="bet-label">All Bet </span>
                                            <span className="bat_counter"></span>
                                        </a>
                                    </li>
                                    <li className="nav-item betdata">
                                        <a className="unmatchbet" ng-click="DisplayBets('Match')">
                                            <span className="bet-label">Match Bet</span>
                                            <span className="bat_counter"></span>
                                        </a>
                                    </li>
                                    <li className="nav-item betdata">
                                        <a className="unmatchbet" ng-click="DisplayBets('Fancy')">
                                            <span className="bet-label">Fancy Bet</span>
                                            <span className="bat_counter"></span>
                                        </a>
                                    </li>
                                    <li className="nav-item betdata">
                                        <a className="unmatchbet" ng-click="DisplayBets('Casino')">
                                            <span className="bet-label blinking">Casino Bet</span>
                                            <span className="bat_counter"></span>
                                        </a>
                                    </li>
                                    <li className="nav-item betdata">
                                        <a className="unmatchbet" ng-click="DisplayBets('Matka')">
                                            <span className="bet-label blinking">Matka Bet</span>
                                            <span className="bat_counter"></span>
                                        </a>
                                    </li>
                                    <li className="nav-item full-screen"></li>
                                </ul>
                            </div>
                            <div id="MatchUnMatchBetaData">
                                <div id="accountView" role="main">
                                    <span id="msg_error"></span>
                                    <span id="errmsg"></span>
                                    <div className="balance-panel-body">
                                        <div className="table-responsive sports-tabel">
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr className="heading_user_table">
                                                        <td>Team</td>
                                                        <td>Mode</td>
                                                        <td ng-if="BetType!='Match'">Run</td>
                                                        <td>Rate</td>
                                                        <td>Amount</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="heading_user_table" ng-repeat="row in MatchFancyBets">
                                                        <td ng-bind="row.TeamOrFancy"></td>
                                                        <td ng-bind="row.Mode=='K' ? 'LAGAI' : row.Mode=='L' ? 'KHAI' : row.Mode"></td>
                                                        <td ng-bind="row.Run" ng-if="BetType!='Match'"></td>
                                                        <td ng-bind="row.Rate"></td>
                                                        <td ng-bind="row.Amount"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav> */}
                    <div className="logo" style={{left:'5px'}}>
                        <Link className="site_title endcooki" style={{ 'textDecoration': 'none' }} to="/Dashboard">
                            <img src="/images/run99.png" alt="WBT99" height="40" />
                        </Link>
                    </div>
                    <div className="mike" style={{backgroundColor:'#622569',whiteSpace: 'nowrap'}}>
                        <div className="marquee">
                            <div className="marquee-track" style={{ color: 'white' }}>
                                <i className="fa fa-bullhorn" aria-hidden="true"></i> {myLiveMessage}
                            </div>
                        </div>
                    </div>
                    <div className="balancewallet">
                        <Link className="Wallet" to="/Dashboard">
                            Chips: <span id="TotalCoins">{(Coins - Exposure).toFixed(2)}</span>
                        </Link>
                        <Link className="Wallet" to="Exposure">
                            Expo : <span id="UsedCoins">{Exposure}</span>
                        </Link>
                    </div>
                    <div className="right_user-menu" style={{ marginRight: '-10px' }}>
                        <div className="dropdown">
                            <span className=" dropbtn dropdown-toggle" type="button" data-toggle="dropdown">
                                {ClientCode} ({ClientName})
                            </span>
                            <ul className="dropdown-content ">
                                <li className="label-user">
                                    <Link to="ChangePassword">
                                        <i className="fas fa-unlock-alt"></i> Change Password
                                    </Link>
                                </li>
                                <li className="label-user">
                                    <Link className="endcooki" to="Logout">
                                        <i className="fas fa-sign-out-alt"></i> Log Out
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <br />
                        <div className="mobile-belance" style={{ marginRight: '-40px' }}>
                            <span>
                                <Link className="Wallet" to="/Dashboard">
                                    Chips: <span id="TotalCoinsMob">{(Coins - Exposure).toFixed(2)}, </span>
                                </Link>
                            </span>
                            <span>
                                <Link className="Wallet" to="Exposure">
                                    Expo : <span id="UsedCoinsMob">{Exposure}</span>
                                </Link>
                            </span>
                        </div>
                    </div>
                    {/* <span className="bettoggle"> Bets </span> */}
                </div>
            </header>

            <div className="mikemobile" style={{backgroundColor:'#4d0355ff'}}>
                <div className="marquee">
                    <div className="marquee-track" style={{ color: 'white' }}>
                        <i className="fa fa-bullhorn" aria-hidden="true"></i> {myLiveMessage}
                    </div>
                </div>
            </div>

            <div className="menu">
                <nav id="cssmenu">
                    <ul className="nav">
                        <li>
                            <label className="button" htmlFor="drawer-toggle" id="drawer-toggle-close"></label>
                        </li>
                        <li>
                            <Link to="">Home </Link>
                        </li>
                        <li>
                            <Link to="Statements">Account Statement </Link>
                        </li>
                        <li>
                            <Link to="MyLedger">My Ledger </Link>
                        </li>
                        {/* <li>
                            <Link to="Passbook">Passbook </Link>
                        </li> */}
                        <li>
                            <Link to="LiveGames">Live Games </Link>
                        </li>
                    </ul>
                </nav>
            </div>

            <div className="header d-lg-none d-md-none">
                <div className="container">
                    <nav className="bottom-nav">
                        <div className="bottom-nav-item active">
                            <Link to="">
                                <div className="bottom-nav-link">
                                    <i className="fas fa-home"></i>
                                    <span>Home</span>
                                </div>
                            </Link>
                        </div>
                        <div className="bottom-nav-item">

                            <Link to="MyLedger">
                                <div className="bottom-nav-link">
                                    <i className="fas fa-thumbtack"></i>
                                    <span>My Ledger</span>
                                </div>
                            </Link>

                        </div>
                        <div className="bottom-nav-item">
                            <Link to="LiveGames">
                                <div className="bottom-nav-link">
                                    <i className="fas fa-money-bill-alt"></i>
                                    <span>Live Casino</span>
                                </div>
                            </Link>
                        </div>
                        <div className="bottom-nav-item">
                            <Link to="Statements">
                                <div className="bottom-nav-link">
                                    <i className="fas fa-book"></i>
                                    <span>Statement</span>
                                </div>
                            </Link>
                        </div>
                        {/* <div className="bottom-nav-item">
                            <Link to="Passbook">
                                <div className="bottom-nav-link">
                                    <i className="fas fa-money-bill-alt"></i>
                                    <span>Passbook</span>
                                </div>
                            </Link>
                        </div> */}
                        <div className="bottom-nav-item">
                            <Link to="Logout">
                                <div className="bottom-nav-link">
                                    <i className="fas fa-user-circle"></i>
                                    <span>Logout</span>
                                </div>
                            </Link>
                        </div>
                    </nav>
                </div>
            </div>

            <div className="main-wrapper">
                <div className="wrapper">
                    <aside id="mySidenav" className="sidenav left-side">
                        <div className="side-inner">
                            <div className="tab-content">
                                <div id="live" className="  ">
                                    <nav id="menu" className="shadow corner all">
                                        <div className="dropdown">
                                            <a className="dropdown-toggle" data-toggle="dropdown" href="">
                                                <img src="/assets/images/cricket.png" className="icon-sport" />Cricket <span className="match_count">
                                                    <i className="fas fa-chevron-down"></i>
                                                </span>
                                            </a>
                                            <div className="collapse">
                                                <div style={{ padding: '0px 15px', borderBottom: '1px solid rgb(221, 221, 221)' }}>
                                                    <a className="event-name" href="dashboard/events/28569726"> ICC CRICKET WORLD CUP </a>
                                                </div>
                                                <div style={{ padding: '0px 15px', borderBottom: '1px solid rgb(221, 221, 221)' }}>
                                                    <a className="event-name" href="dashboard/events/1810091512"> Assembly election 2023 </a>
                                                </div>
                                                <div style={{ padding: '0px 15px', borderBottom: '1px solid rgb(221, 221, 221)' }}>
                                                    <a className="event-name" href="dashboard/events/32793045"> South Africa v Australia </a>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </aside>
                    <main className="main-content">
                        <div className="main-inner">

                            <Outlet />

                            <div style={{paddingBottom:'70px'}}>
                                <br></br><br></br>
                            </div>
                            
                        </div>
                        
                    </main>                   
                    
                </div>
            </div>

            <div id="BetResponse"></div>

        </>
    )
}
export default Layout;